var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReferenceIconUpdate(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_11751",
    "data-name": "Group 11751",
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.652,
    height: 19.652,
    viewBox: "0 0 19.652 19.652",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_49478",
    "data-name": "Path 49478",
    d: "M293.5,12.284l-3.5-3.5v3.5Z",
    transform: "translate(-278.869 -8.446)",
    fill: "#3f63f1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49479",
    "data-name": "Path 49479",
    d: "M13.45,14.009l-.043.041a1.726,1.726,0,0,1-.459.35L10.1,15.893a1.734,1.734,0,0,1-.8.2,1.732,1.732,0,0,1-1.588-1.044H3.263a.576.576,0,0,1,0-1.152H7.634a1.748,1.748,0,0,1,.133-.333L8.8,11.592H3.263a.576.576,0,1,1,0-1.152H9.42l2.3-2.3H3.263a.576.576,0,1,1,0-1.152h9.611l2-2H10.555a.576.576,0,0,1-.576-.576V0H1.727A1.729,1.729,0,0,0,0,1.727v16.2a1.729,1.729,0,0,0,1.727,1.727H13.242a1.729,1.729,0,0,0,1.727-1.727V12.49ZM19.2,6.628a1.535,1.535,0,1,0-2.171-2.171L16.489,5l2.171,2.171Z",
    fill: "#3f63f1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_49480",
    "data-name": "Path 49480",
    d: "M227.274,159.768a.576.576,0,0,0,.777.777l2.475-1.3-1.956-1.956Zm2-3.4,4.885-4.885,2.171,2.171-4.885,4.885Z",
    transform: "translate(-218.487 -145.672)",
    fill: "#3f63f1"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReferenceIconUpdate);
export default __webpack_public_path__ + "static/media/referenceIconUpdate.c2f514af9ccf225015349b6b0132a6fd.svg";
export { ForwardRef as ReactComponent };